/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/authcontext/AuthContext";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Material Dashboard 2 React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Material Dashboard 2 React routes
import routes from "routes";

// Material Dashboard 2 React contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import Dashboard from "layouts/dashboard";

// extra pages
import AddProcuctVariant from "pages/manageProduct/AddProductVariant";
import ViewDetail from "pages/viewdetails/ViewDetail";
import EditProduct from "pages/manageProduct/EditProduct";
import EditUser from "pages/users/EditUser";
import EditShop from "pages/shops/EditShop";
import EditBmGuide from "pages/bodymeasurementGuide/EditBmGuide";
import EditBmShapes from "pages/bodyMeasurementShapes/EditBmShapes";
// import EditComplaintTypes from "./pages/complaintTypes/EditComplaintTypes";
// import EditComplaintTypesReasons from "./pages/complaintTypesReasons/EditComplaintTypesReason";
import EditPage from "pages/managepages/EditPage";
import EditPrices from "pages/manageDeliveryPrice/EditPrices";
import EditProductVarinat from "pages/manageProduct/EditProductVariant";
import EditCategory from "pages/manageCategory/EditCategory";
import Categorydatalist from "pages/manageCategory/Categorydatalist";
import HomeCategory from "pages/manageCategory/HomeCategory";
import CategoriesList from "pages/manageCategory/CategoriesList";
// import Viewdetails from "pages/manageCategory/Viewdetails";

import Review from "pages/Review/Review";
import Ordertracking from "pages/Orders Tracking/Ordertracking";
import RefundTracking from "pages/Orders Tracking/RefundTracking";
import ExchangeTracking from "pages/Orders Tracking/ExchangeTracking";
import ViewDetails from "pages/Orders Tracking/ViewDetails";

import Ignored from "pages/Review/Ignored";
import AddNewCategory from "pages/manageCategory/AddNew";
import Signup from "layouts/authentication/sign-up";
import Signin from "layouts/authentication/sign-in";
import Terms_of_views from "pages/Terms of views/Terms_of_views";
import Privacy_Policy from "pages/Privacy Policy/Privacy_Policy";
import Personal_data from "pages/Personal Data/Personal_data";
import About_us from "pages/About us/About_us";
import License_and_Agreement from "pages/License and Agreement/License_and_Agreement";
import Corporate_information from "pages/Corporate information/Corporate_information";
export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/signin");
    }
  }, [user]);

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      // if (route.collapse) {
      //   return getRoutes(route.collapse);
      // }

      if (route.route) {
        if (route.hasOwnProperty("children")) {
          console.log(route.children);
          route.children?.map((ch) => {
            return <Route exact path={ch.route} element={ch.component} key={ch.key} />;
          });
        } else {
          return <Route exact path={route.route} element={route.component} key={route.key} />;
        }
      }

      return null;
    });

  //  get filtered routes for other users than supreradmin-:

  const filteredRoutes = getRoutes.filter;

  // const configsButton = (
  //   <MDBox
  //     display="flex"
  //     justifyContent="center"
  //     alignItems="center"
  //     width="3.25rem"
  //     height="3.25rem"
  //     bgColor="white"
  //     shadow="sm"
  //     borderRadius="50%"
  //     position="fixed"
  //     right="2rem"
  //     bottom="2rem"
  //     zIndex={99}
  //     color="dark"
  //     sx={{ cursor: "pointer" }}
  //     onClick={handleConfiguratorOpen}
  //   >
  //     <Icon fontSize="small" color="inherit">
  //       settings
  //     </Icon>
  //   </MDBox>
  // );

  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="Material Dashboard 2"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName="Material Dashboard 2"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {/* {configsButton} */}
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {routes.map((route) => {
          if (route.hasOwnProperty("children")) {
            // Use `return` to return the mapped Route elements
            return route.children?.map((ch) => (
              <Route exact path={ch.route} element={ch.component} key={ch.key} />
            ));
          } else {
            return <Route exact path={route.route} element={route.component} key={route.key} />;
          }
          // Make sure to handle the case where there's no route
        })}
        <Route path="/view_details" element={<ViewDetail />} />
        <Route path="/add_product_variant" element={<AddProcuctVariant />} />
        <Route path="/edit_product/:_id" element={<EditProduct />} />
        <Route path="/edit_user" element={<EditUser />} />
        <Route path="/edit_shop/:id" element={<EditShop />} />
        <Route path="/edit-body-measurement/:_id" element={<EditBmGuide />} />
        <Route path="/edit-body-measurement-shapes/:_id" element={<EditBmShapes />} />
        {/* <Route path="/edit-complaint-type" element={<EditComplaintTypes />} />
        <Route path="/edit-complaint-type-reasons" element={<EditComplaintTypesReasons />} /> */}
        <Route path="/edit-manage-page" element={<EditPage />} />
        <Route path="/edit-prices" element={<EditPrices />} />
        <Route path="/edit-product-variant" element={<EditProductVarinat />} />
        <Route path="/edit-category" element={<EditCategory />} />
        <Route path="/categorydatalist" element={<Categorydatalist />} />
        <Route path="/HomeCategory" element={<HomeCategory />} />
        <Route path="/CategoriesList" element={<CategoriesList />} />
        <Route path="/Review" element={<Review />} />
        <Route path="/ignored" element={<Ignored />} />
        <Route path="/Terms_of_views" element={<Terms_of_views />} />
        <Route path="/Privacy_Policy" element={<Privacy_Policy />} />
        <Route path="Personal_data" element={<Personal_data />} />
        <Route path="About_us" element={<About_us />} />
        <Route path="/ordertracking" element={<Ordertracking />} />
        <Route path="/ViewDetails"element={<ViewDetails/>}/>
        <Route path="/refundtracking" element={<RefundTracking />} />
        <Route path="/exchangetracking" element={<ExchangeTracking />} />
        <Route path="/License_and_Agreement" element={<License_and_Agreement />} />
        <Route path="/Corporate_information" element={<Corporate_information />} />

        {/* <Route path="/viewdetails" element={<Viewdetails />} /> */}

        {/* <Route path="/add-category" element={<AddNewCaCegory />} /> */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="*" Component={<Dashboard />} />
      </Routes>
    </ThemeProvider>
  );
}
